module.exports = {

    DASHBOARD_DOMAIN: 'https://agents.mobupps.com',
    DATABASE_OFFERS_DEFAULT_PAGINATION_VALUE: 1,
    DATABASE_OFFERS_DEFAULT_PAGINATION_LIMIT: 100,
    DATABASE_OFFERS_DEFAULT_SORT_BY: 'id',
    DATABASE_OFFERS_DEFAULT_SORT_TYPE: 'DESC',

    SORT_TYPE_DESC: 'DESC',
    SORT_TYPE_ASC: 'ASC',

    AJAX_NOT_RUNNING: 'AJAX_NOT_RUNNING',
    AJAX_IN_PROGRESS: 'AJAX_IN_PROGRESS',
    AJAX_FINISHED: 'AJAX_FINISHED',

    MULTISELECT_AFFILIATES: 'MULTISELECT_AFFILIATES',
    MULTISELECT_TUNE_ADVERTISERS_BY_AGENT: 'MULTISELECT_TUNE_ADVERTISERS_BY_AGENT',
    MULTISELECT_TUNE_PUBLISHER_BY_AGENT: 'MULTISELECT_TUNE_PUBLISHER_BY_AGENT',

    MULTISELECT_MATADATA: {
        MULTISELECT_TUNE_ADVERTISERS_BY_AGENT: {
            name: 'Advertisers',
            method: 'UTILITIES_TUNE_ADVERTISERS_BY_AGENT_GET',
            route: 'UTILITIES_TUNE_ADVERTISERS_BY_AGENT_ROUTE',
            accessor: 'MULTISELECT_TUNE_ADVERTISERS_BY_AGENT',
            state: 'state.utilities.advertiserListByAgent',
            allowExclude: true
        },
        MULTISELECT_TUNE_PUBLISHER_BY_AGENT: {
            name: 'Affiliates',
            method: 'UTILITIES_TUNE_PUBLISHER_BY_AGENT_GET',
            route: 'UTILITIES_TUNE_PUBLISHER_BY_AGENT_ROUTE',
            accessor: 'MULTISELECT_TUNE_PUBLISHER_BY_AGENT',
            state: 'state.utilities.publisherListByAgent',
            allowExclude: true
        },
    },


    CLIENT_SIDE_AGENT_ADVERTISER_COMMISSION_REPORT: 'advertiser-commission-report',
    CLIENT_SIDE_AGENT_PUBLISHER_COMMISSION_REPORT: 'publisher-commission-report',
}